<template>
  <div>
    <div class="info-head spaceBetween">
      <span>Business Verification</span>
      <el-button type="text" :icon="isOpen?'el-icon-arrow-up':'el-icon-arrow-down'" @click="isOpen=!isOpen"></el-button>
    </div>
    <div v-show="isOpen">
      <OtherBusinessKYCInfo
        v-if="area != 'HK'"
        :Business.sync="Business"
        :Communication.sync="Communication"
        :Location.sync="Location"
      ></OtherBusinessKYCInfo>
      <HKbusinessKYCInfo
        v-else
        :Business.sync="Business"
        :Communication.sync="Communication"
        :Location.sync="Location"
      ></HKbusinessKYCInfo>
    </div>

  </div>
</template>

<script>
import OtherBusinessKYCInfo from "@/views/authentication/businessKYC/components/OtherBusinessKYCInfo.vue";
import HKbusinessKYCInfo from "@/views/authentication/businessKYC/components/HKbusinessKYCInfo.vue";
export default {
  components: { OtherBusinessKYCInfo, HKbusinessKYCInfo },
  props: {
    pageData: {
      type: Object,
      default:()=>{
        return {}
      }
    },
  },
  data() {
    return {
      area: "",
      Business: {},
      Communication: {},
      Location: {},
      isOpen:true
    };
  },
  computed: {},
  methods: {
    init() {
      this.area = this.pageData && this.pageData.CountryCode;
      this.Business = this.pageData && this.pageData.DataFields.Business;
      this.Communication = this.pageData && this.pageData.DataFields.Communication;
      this.Location = this.pageData && this.pageData.DataFields.Location || {};
      this.Location.Address1 = this.Location.AdditionalFields && this.Location.AdditionalFields.Address1;
    },
  },
  watch: {
    pageData: {
      deep: true,
      handler(newVal) {
        this.init();
      },
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped lang="scss">
.info-head {
  padding: 0.24rem 0.32rem;
  border-bottom: 1px solid #f0f0f0;
  font-size: 0.22rem;
  font-weight: bold;
}
</style>
